
        import { localDayAndTime } from "@/js/local_time"

        export default {
          mounted() {
            this.sync()
            this.el.addEventListener("input", () => this.fill())
          },
          updated() { this.sync() },
          sync() {
            this.hydrate()
            this.fill()
          },
          hydrate() {
            const runAt = this.el.dataset.runAt
            if (!runAt) return
            const at = new Date(runAt)
            const pad = (n) => String(n).padStart(2, "0")
            const { day, time } = localDayAndTime(at)
            this.restore('[name$="[schedule_at]"]',
              `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}T${time}`)
            this.restore('[name$="[recurring_day]"]', day)
            this.restore('[name$="[recurring_time]"]', time)
          },
          restore(selector, value) {
            const el = this.el.querySelector(selector)
            if (el && !el.value) el.value = value
          },
          fill() {
            const tz = this.el.querySelector('[name="launch[timezone]"]')
            if (tz) tz.value = Intl.DateTimeFormat().resolvedOptions().timeZone
            const local = this.el.querySelector('[name$="[schedule_at]"]')
            const utc = this.el.querySelector('[name="launch[schedule_at_utc]"]')
            if (utc) utc.value = local && local.value ? new Date(local.value).toISOString() : ""
          },
        }
      